import { cn } from '@change/ds-utils';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';
import type { PostPreviewSizes } from '../../types';

import { bodyShapes, bodySkeletonGaps } from './body.constants';
import { BodyTextStyles } from './Body.styles';

export function BodyLoading({ loading, size }: { loading: boolean; size: PostPreviewSizes }) {
	return (
		<SkeletonContainer
			loading={loading}
			className={cn('flex flex-col', bodySkeletonGaps[size])}
			data-testid="body-loading-root"
		>
			<div className={cn(BodyTextStyles({ size }), 'flex flex-col', bodyShapes.gaps[size])}>
				{bodyShapes.textSkeletons.paragraphs.map((paragraph) => {
					return (
						<div key={paragraph.key} className={cn('flex flex-col', paragraph.gaps[size])}>
							{paragraph.rectangles.map((rectangle) => (
								<Rectangle rounded key={rectangle.key} className={rectangle.sizes[size]} />
							))}
						</div>
					);
				})}
			</div>
			<Rectangle className={bodyShapes.imageSkeleton.sizes[size]} />
		</SkeletonContainer>
	);
}
